import React from "react";
import styled from "styled-components"
import colors from "../../styles/colors";
import fonts from "../../styles/fonts";

const StyledLink = styled.a`
  ${fonts.montserratBold};
  padding: ${props => props.small ? '12px 20px' : '16px 48px'};
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  font-size: 12px;
  line-height: 16px;

  color: ${colors.white};
  background: ${colors.green};
  border: 1px solid ${colors.green};
  
  &:hover {
    background: ${colors.white};
    color: ${colors.green};
    border-color: ${colors.green};
  }
`;

const ExternalLinkButton = ({href, className, children, small, sameTab}) => {
  return (
    <StyledLink href={href}
       small={small}
       className={className}
       target={sameTab ? undefined : "_blank"}
       rel={sameTab ? undefined : "noopener noreferrer"}>
      {children}
    </StyledLink>
  );
};

export default ExternalLinkButton;
